import { language as lan_copyright } from "./copyright";
/**
 * 多语言配置，调用$translate.instant("key") 或者 translate filter在html上绑定 如： {{ 'key' | translate }}，即可获取
 */
let language = {
    // 图片版权声明
    ...lan_copyright,
    BUILDER_PROPERTY: "属性",
    BUILDER_DESIGN_NAME: "设计的名字:",
    BUILDER_COPYRIGHT: "图片版权",
    BUILDER_CANCEL_BTN: "取消",
    BUILDER_ADD_TO_CART_BTN: "加入购物车",
    BUILDER_UPDATE_BTN: "更新",
    /*************************** 参数校验 *************************/
    // builderUrl地址参数校验提示
    BUILDER_URL_INVALID_PARAM_TITLE: "无效的参数",
    // builderUrl地址参数缺失
    BUILDER_URL_PARAM_MISSING_CONTENT: "尝试打开我们的在线设计器时，缺少参数，请刷新页面后重试。",
    // builderUrl地址参数错误
    BUILDER_URL_PARAM_ERROR_CONTENT: "尝试打开我们的在线设计器时，参数不正确，请刷新页面后重试。",
    // A104P001
    // 参数缺失--一个 A104P001
    "A104P001_1": "尝试打开我们的在线设计器时，参数 '{{missingField}}' 缺失。",
    // 参数缺失--多个 A104P002
    "A104P001_2": "尝试打开我们的在线设计器时，参数 {{missingFields}} 缺失。",
    // A104P002
    // 参数错误--一个 A104P003
    "A104P002_1": "尝试打开我们的在线设计器时，参数 '{{correctField}}' 不正确。",
    // 参数错误-- 多个 A104P005
    "A104P002_2": "尝试打开我们的在线设计器时，参数 {{correctFields}} 不正确。",
    /*************************** builder页面初始化 *************************/
    BUILDER_ISSUE_PAGE_LOADING_TITLE: "页面加载问题",
    BUILDER_ISSUE_PAGE_LOADING_CONTENT: "加载此页面时发生了错误，请刷新页面后重试。",
    // iframebuilder高度获取失败提示
    "A104O001": "尝试加载在线设计器时，'iframe' 元素的高度未定义。",
    
    /*************************** builder页面在线设计初始化 *************************/
    BUILDER_ISSUE_ONLINE_DESIGNER_TITLE: "在线设计器问题",
    BUILDER_ISSUE_ONLINE_DESIGNER_CONTENT: "打开在线设计器时发生了错误，请刷新页面后重试。",
    // productInstance实例不存在
    "A104A004": "未找到您的在线设计，或者您传递了错误的设计ID，请联系技术支持 {{supportmail}}。",
    // 产品配置问题
    "A104A005": "产品配置似乎有问题，导致页面无法正常初始化，请重试或联系技术支持 {{supportmail}}。",
    BUILDER_ISSUE_ONLINE_DESIGNER_LOADING_TITLE: "在线设计器问题",
    BUILDER_ISSUE_ONLINE_DESIGNER_LOADING_CONTENT: "加载此在线设计器时发生了错误，请刷新页面后重试。",
    // window对象获取失败提示，无法添加保存在线设计事件监听（builder-V5及以上版本）
    "A1040002": "尝试加载在线设计器时，'window' 对象未定义。",
    // iframeWindow对象获取失败提示（builder-V5以下版本）
    "A104P004": "尝试加载在线设计器时，'iframe' 元素的窗口未定义。",
    
    /*************************** builder页面在线设计参数校验 *************************/
    BUILDER_ONLINE_DESIGNER_INVALID_PARAM_TITLE: "在线设计器问题",
    // 参数缺失
    BUILDER_ONLINE_DESIGNER_INVALID_PARAM_CONTENT: "尝试打开我们的在线设计器时，缺少参数，请刷新页面后重试。",
    // 参数错误
    BUILDER_ONLINE_DESIGNER_INVALID_PARAM_ERROR_CONTENT: "尝试打开我们的在线设计器时，参数不正确，请刷新页面后重试。",
    
    // iframeBuilder定制区域初始化参数缺失 | iframeBuilder定制区域初始化参数缺失_缺少必填ID信息（propertyModelId、productId、productInstanceId、storeProductId、orderItemId）
    // 初始化在线设计参数Id类型缺失 A104B001
    "A104B001": "尝试打开我们的在线设计器时，参数 '{{missingField}}' 缺失。",
    // 初始化在线设计参数-token参数缺失 A104B002
    "A104B002": "尝试打开我们的在线设计器时，未授权或缺少授权。",
    // iframeBuilder定制区域初始化参数缺失_根路径地址格式不正确
    'A104B003': "尝试打开我们的在线设计器时，参数 '{{correctField}}' 不正确。",
    
    /*************************** builder页面保存在线设计 *************************/
    // 保存在线设计失败提示_可重试
    BUILDER_SAVE_DESIGN_ERROR_TITLE: "无效的在线设计",
    BUILDER_SAVE_DESIGN_ERROR_CONTENT: "尝试保存在线设计器时发生了错误，您可以点击 [重试] 立即保存或点击 [取消] 稍后保存。",
    // 保存在线设计失败提示_不可重试
    BUILDER_SAVE_DESIGN_FAILED_CONTENT: "尝试保存在线设计器时发生了错误，请重试或联系技术支持 {{supportmail}}。",
    // 保存在线设计失败提示_在线定制类型暂不支持
    "A104B004": "尝试保存在线设计器时，参数 'source' 不正确。",
    "A104P005": "尝试保存在线设计器时，'iframe' 元素的窗口未定义。",
    
    /*************************** 添加购物车项 *************************/
    // 添加产品到购物车失败提示_可重试
    BUILDER_ADD_TO_CART_ERROR_TITLE: "添加到购物车无效",
    BUILDER_ADD_TO_CART_ERROR_CONTENT: "尝试将产品添加到购物车时发生了错误，您可以点击 [重试] 立即添加或点击 [取消] 稍后添加。",
    // 产品购买数量小于“最小购买数量”
    "A104B2700419": "当前产品购买数量小于最小购买数量，请修改购买数量后重试。",
    // 产品不是一个成品产品（完备产品），无法添加到购物车
    "A104B200064": "产品处于不完整状态，请检查在线定制是否完成后重试。",
    // 添加产品到购物车失败提示_可重试（产品配置）
    BUILDER_ADD_TO_CART_ERROR_FAILED_TITLE: "添加到购物车无效",
    BUILDER_ADD_TO_CART_ERROR_DY_PRODUCT_CONTENT: "尝试将产品添加到购物车时发生了错误，请稍后再试。",
    // 产品计价问题
    "A104B1200001": "尝试将产品添加到购物车时，产品定价出现错误，请重试或联系技术支持 {{supportmail}}。",
    // 产品配置问题 skuProductId  configValue: ConfigValue not match ProductConfigBom Entity!"
    "A104B2700401": "尝试将产品添加到购物车时，产品配置出现错误，请重试或联系技术支持 {{supportmail}}。",
    
    /*************************** 更新购物车项 *************************/
    // 更新购物车项设计失败提示
    BUILDER_UPDATE_CART_ITEM_ERROR_TITLE: "更新购物车项无效",
    BUILDER_UPDATE_CART_ITEM_ERROR_CONTENT: "尝试更新购物车项时发生了错误，您可以点击 [重试] 立即添加或点击 [取消] 稍后添加。",
    BUILDER_UPDATE_CART_ITEM_FAILED_CONTENT: "尝试更新购物车项时发生了错误，请稍后再试。",
    
    /*************************** 更新订单项 *************************/
    // 更新订单项设计失败提示
    BUILDER_UPDATE_ORDER_ITEM_ERROR_TITLE: "更新订单项无效",
    BUILDER_UPDATE_ORDER_ITEM_ERROR_CONTENT: "尝试更新订单项时发生了错误，您可以点击 [重试] 立即更新或点击 [取消] 稍后更新。",
    BUILDER_UPDATE_ORDER_ITEM_FAILED_CONTENT:"尝试更新订单项时发生了问题，请稍后再试。",
    // 修改的订单项:id,对应的实体不存在 || 修改的ProductInstance:id对应的实体不存在
    "A104B311874": "未找到您的在线设计，或者您的订单项未找到。您传递了错误的设计ID，请联系技术支持 {{supportmail}}。",
    
    /*************************** builder页面保存在线设计 *************************/
    
    // 项目名称格式不正确（1-20） projectName格式提示信息 
    BUILDER_PROJECT_NAME_FORMAT_TITLE: "设计名称无效",
    BUILDER_PROJECT_NAME_FORMAT_CONTENT: "请输入长度在1到20之间的设计名称，请重试。",
};

export { language }
